import { render, staticRenderFns } from "./uploadHomework.vue?vue&type=template&id=74c64d58&scoped=true"
import script from "./uploadHomework.vue?vue&type=script&lang=js"
export * from "./uploadHomework.vue?vue&type=script&lang=js"
import style0 from "./uploadHomework.vue?vue&type=style&index=0&id=74c64d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c64d58",
  null
  
)

export default component.exports